import styled from 'styled-components';

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 400px;
  min-height: 500px;
  padding: 32px 16px 24px 16px;
  border-radius: 8px;
  background: #ffffff;
  box-sizing: border-box;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 24px 20px;
  }
`;

export default FormWrapper;
